import ActionTypeContrato from "../ActionTypeContrato";

export default class CargaDeContratosBuscados extends ActionTypeContrato {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = false;
        nuevoEstado.data = this.payload;
        return nuevoEstado;
    }
}
